import productEnum from './product-enum';

export default class productService {
  static Configure() {
    return {
      product: {
        id: productEnum.MATHLETICS.id,
        name: productEnum.MATHLETICS.name
      }
    };
  }

  static getProductNameById(id) {
    let productName = '';
    if (id) {
      for (const key in productEnum) {
        if (productEnum[key].id === id) {
          productName = productEnum[key].name;
          break;
        }
      }
    }
    return productName;
  }
}



// WEBPACK FOOTER //
// ./helpers/product-service.js